import Input from '../../fields/input/input.component';
import OdinIcon, { OdinIconSize } from '../../odin-icon/odin-icon.component';

export interface TextSearchFieldProps {
  id: string;
  currentValue: string;
  onInputChanged: (searchText?: string) => void;
}

export default function TextSearchField({ currentValue, onInputChanged, id }: TextSearchFieldProps) {
  return (
    <div className="flex bg-mono-1 border border-gray-4 h-full">
      <Input
        name="text-search-filter"
        id={id}
        type="text"
        value={currentValue}
        onChange={onInputChanged}
        inputStyles="focus:outline-hidden leading-6 border-none!"
        trimWhitespace={false}
      />
      <div className="flex shrink items-center pr-1 cursor-pointer">
        <OdinIcon size={OdinIconSize.ExtraSmall} icon="Search" />
      </div>
    </div>
  );
}
